import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { UspsService } from '../../core/services/usps.service';
import { UspsAddressModel } from '../../core/models/ShoppingCart.model';
import { FormGroup } from '@angular/forms';
@Component({
  selector: 'app-usps-dialog',
  templateUrl: './usps-dialog.component.html',
  styleUrls: ['./usps-dialog.component.css']
})
export class UspsDialogComponent implements OnInit {
  ErrorMessage = '';
  IsAddressValid = true;
  UspsFormattedAddress: UspsAddressModel;
  addressForm: FormGroup;
  ShippingFullName = '';
  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private dialogRef: MatDialogRef<UspsDialogComponent>
  , private uspsService: UspsService) { }

  ngOnInit() {
    this.UspsFormattedAddress = new UspsAddressModel();
        if (this.data.IsError) {
          this.IsAddressValid = false;
         // this.ErrorMessage = this.data.Description;
        } else {
          this.ShippingFullName = this.data.Description.FullName;
          this.IsAddressValid = true;
          const data = this.data.Description;
          if (data.Address1 === undefined && data.Address2 !== undefined) {
            this.UspsFormattedAddress.Address1 = data.Address2[0];
          } else {
            this.UspsFormattedAddress.Address1 = data.Address1 === undefined ? '' : data.Address1[0];
          }
          if (data.Address1 === undefined && data.Address2 !== undefined) {
            this.UspsFormattedAddress.Address2 = '';
          } else {
            this.UspsFormattedAddress.Address2 = data.Address2 === undefined ? '' : data.Address2[0];
          }
          // this.UspsFormattedAddress.Address1 = data.Address1 === undefined ? '' : data.Address1[0];
          // this.UspsFormattedAddress.Address2 = data.Address2 === undefined ? '' : data.Address2[0];
          this.UspsFormattedAddress.City = data.City === undefined ? '' : data.City[0];
          this.UspsFormattedAddress.State = data.State === undefined ? '' : data.State[0];
          this.UspsFormattedAddress.Zip5 = data.Zip5 === undefined ? '' : data.Zip5[0];
          this.UspsFormattedAddress.ReturnText = data.ReturnText === undefined ? '' : data.ReturnText[0];
        }

  }

  OnCloseClick() {
    this.dialogRef.close('');
  }

  OnAcceptClick(addressModel: UspsAddressModel) {
    this.dialogRef.close(addressModel);
  }

}



// WEBPACK FOOTER //
// ./src/app/shoppingcart/usps-dialog/usps-dialog.component.ts